@if (formState() === formStateEnum.Idle) {
    <form class="mt-4 w-full">
        <div class="relative flex w-full">
            <div class="relative flex w-full">
                <div class="relative w-full">
                    <input
                        type="email"
                        id="email"
                        class="peer bg-transparent focus:shadow-inner px-3 py-2.5 pr-28 border placeholder-shown:border focus:border-2 disabled:border-0 border-t-transparent focus:border-t-transparent rounded-[7px] outline outline-0 focus:outline-0 size-full font-normal text-lg transition-all"
                        [ngClass]="{
                            'placeholder-shown:border-t-black border-black placeholder-shown:border-black disabled:bg-black':
                                colorMode() === 'black',
                            'placeholder-shown:border-t-white border-white placeholder-shown:border-white disabled:bg-white ':
                                colorMode() === 'white',
                        }"
                        (focus)="umami.track('newsletter-email-focus')"
                        [formControl]="email"
                        autocomplete="email"
                        placeholder=""
                    />
                    <label
                        for="email"
                        class="before:block after:block -top-1 peer-focus:-top-1.5 left-0 before:box-border after:box-border absolute flex after:flex-grow before:mt-[6.5px] after:mt-[6.5px] before:mr-1 after:ml-1 before:border-t after:border-t peer-disabled:before:border-transparent peer-focus:before:border-t-2 peer-placeholder-shown:before:border-transparent peer-disabled:after:border-transparent peer-focus:after:border-t-2 peer-placeholder-shown:after:border-transparent after:border-r peer-focus:after:border-r-2 before:border-l peer-focus:before:border-l-2 before:rounded-tl-md after:rounded-tr-md w-full before:w-2.5 after:w-2.5 h-full before:h-1.5 after:h-1.5 !overflow-visible font-normal text-[11px] peer-focus:text-[11px]peer-disabled:text-transparent peer-placeholder-shown:text-sm truncate leading-tight peer-focus:leading-tight peer-placeholder-shown:leading-[3.75] transition-all before:transition-all after:transition-all pointer-events-none before:pointer-events-none after:pointer-events-none select-none before:content[' '] after:content[' ']"
                        [ngClass]="{
                            'peer-focus:before:!border-black before:border-black after:border-black peer-focus:after:!border-black  peer-focus:text-black peer-disabled:peer-placeholder-shown:text-black peer-placeholder-shown:text-black':
                                colorMode() === 'black',
                            'peer-focus:before:!border-white before:border-white after:border-white peer-focus:after:!border-white  peer-focus:text-white peer-disabled:peer-placeholder-shown:text-white peer-placeholder-shown:text-white':
                                colorMode() === 'white',
                        }"
                    >
                        {{ "newsletter.enterEmail" | translate }}
                    </label>
                </div>
                @if (email.valid) {
                    <button
                        class="top-1 right-1 !absolute bg-primary focus:opacity-[0.85] active:opacity-[0.85] disabled:opacity-50 shadow-black/20 shadow-md hover:shadow-black/40 hover:shadow-lg focus:shadow-none active:shadow-none disabled:shadow-none px-4 py-2 rounded font-semibold text-white text-sm text-center uppercase align-middle leading-[inherit] transition-all disabled:pointer-events-none select-none"
                        type="button"
                        (click)="onSubmit()"
                    >
                        {{ "newsletter.register" | translate }}
                    </button>
                }
            </div>
        </div>
    </form>
}
<div
    class="flex flex-col justify-center items-center"
    data-aos="fade-up"
    data-aos-duration="500"
>
    @if (formState() === formStateEnum.Submitting) {
        <div
            class="mx-auto border-4 border-gray-300 border-t-primary rounded-full w-12 h-12 animate-spin"
        ></div>
    }
    @if (formState() === formStateEnum.Success) {
        <svg
            class="size-16 text-primary"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
        >
            <path stroke="none" d="M0 0h24v24H0z" />
            <path d="M5 12l5 5l10 -10" />
        </svg>
    }
    @if (formState() === formStateEnum.Error) {
        <svg
            class="size-16 text-red-500"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
        >
            <path stroke="none" d="M0 0h24v24H0z" />
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
        <p class="mt-2 text-red-500">
            {{ "newsletter.error" | translate }}
        </p>
    }
</div>
